import ReactDOM from 'react-dom';

import { Configuration, FileItem } from '@pega/cosmos-react-core';

const createFileItemElement = (win: typeof globalThis): new () => HTMLElement => {
  return class FileItemElement extends win.HTMLElement {
    static get observedAttributes() {
      return ['data-progress', 'data-error'];
    }

    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
    }

    attributeChangedCallback() {
      this.mount();
    }

    mount() {
      const error = this.getAttribute('data-error') ?? undefined;
      const progress = !error ? Number(this.getAttribute('data-progress')) : undefined;
      const name = this.getAttribute('data-name') ?? '';
      const url = this.getAttribute('data-url') ?? '';
      const id = this.getAttribute('data-id') ?? '';
      if (this.shadowRoot) {
        ReactDOM.render(
          <Configuration portalTarget={this.shadowRoot} styleSheetTarget={this.shadowRoot}>
            <FileItem
              id={id}
              name={name}
              progress={progress}
              onCancel={() => {
                this.remove();
              }}
              url={url}
              format={name?.split('.')?.pop()}
              error={error}
            />
          </Configuration>,
          this.shadowRoot
        );
        this.shadowRoot
          .querySelector('button[aria-label*="Cancel"]')
          ?.setAttribute('tabindex', '-1');
      }
    }

    connectedCallback() {
      this.mount();
      this.setAttribute('contenteditable', 'false');
    }

    disconnectedCallback() {
      ReactDOM.render([], this);
    }
  };
};

export default createFileItemElement;
